import gql from 'graphql-tag'

export default gql`
  mutation SetSpendPrefundAmount($input: spendPrefundAmountInput) {
    setSpendPrefundAmount(input: $input) @client {
      value
    }
  }
`
